import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import { ParkingSymbol } from 'components/common';
import { CustomTabs2, CustomTabs3 } from 'components/elements';
import { DisappointedIcon } from 'assets/Icons';
import { unRegistrePhoto } from 'redux/actions/photo';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';
import LocalParkingEvents from './LocalParkingEvents';
import LocalParkingHosts from './LocalParkingHosts';
import ParkingZones from './ParkingZones';
import MobileOperatorTasks from './MobileOperatorTasks';
import ParkingCards from './ParkingCards';
import {isComponentVisibleForUser} from 'utils';
import CheckIcon from '@material-ui/icons/Check';
import EventNoteIcon from '@material-ui/icons/EventNote';
import ParkingHostCard from 'components/common/ParkingHostCard';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PieChartIcon from '@material-ui/icons/PieChart';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ParkingFavoriteCard from 'components/common/ParkingFavoriteCard';
import {updateHostFavorite} from '../../../redux/actions/hosts';
import {updateFavoriteZone} from '../../../redux/actions/zones'
import NotInterestedIcon from '@material-ui/icons/NotInterested';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(1),
  },
  container2: {
    display: 'flex',
    alignItems: 'flexStart',
    flexDirection: 'row',
    marginBottom: theme.spacing(3.5),
  },
  container3: {
    display: 'flex',
    alignItems: 'left',
    flexDirection: 'column',
  },
  titleWrapper: {
    marginTop: '15px',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  title: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  symbol: {
    marginBottom: theme.spacing(2),
  },
  disconnectedContent: {
    width: '100%',
    height: '416px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.base[300],
    textAlign: 'center',
  },
  disconnectedIcon: {
    marginBottom: theme.spacing(1.5),
  },
  onlineSwitchLabel: {
    marginRight: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    fontSize: 25,
    fontWeight: 700,
    color: '#000000'
  },
  favoriteContainer: {
    display: 'flex',
    flexDirection: 'row',
    // na root stylu je tranformace, zde musí být reverzní, jinak 100vn nefunguje
    maxWidth: props => `calc((100vw*1.25) - ${props.open})`,
    overflowX: 'auto',
    scrollbarWidth: 'thin',
  },
  line: {
    border: 'solid 1px #dcdcdc', marginTop: '5px', marginBottom: '20px'
  }
}));

function LocalParking(props) {
  const { t } = useTranslation();
  const open = useSelector((state) => state.httpserviceData.menuopen);
  const classes = useStyles({open: open?'760px':'520px'});

  const {
    selected,
    selectedHostName,
    setSelectedHostName,
    handleTaskCreateOpen,
    handleTaskDetailOpen,
    handleCameraDetailOpen,
    handleEditZoneOpen,
    handleCardDetailOpen,
    handleCreateCardOpen,
    handleEditCardOpen,
    handleBlockCardOpen,
    handleConfirmCardOpen,
    events,
    favorites,
    sseParkingHosts,
    occupancy,
    withDetail,
    unRegistrePhoto,
    sipCall,
    sipStatus,
    calls,
    userUseCases,
    updateHostFavorite,
    updateFavoriteZone,
    selectParking
  } = props;

  const [activeTab, setActiveTab] = useState(selected.connectionType==='WIMQ'?1:0);

  const getHostByHostName = (hostName) => {
    if (hostName && sseParkingHosts) {
      const s = sseParkingHosts.filter((s) => s.hostName === hostName);
      if (s && s.length > 0) {
        return s[0];
      }
    }
  };

  const handleChangeTab = (value) => {
    if (value !== 0) {
      if (activeTab === 0) {
        const host = getHostByHostName(selectedHostName);
        if (host) {
          unRegistrePhoto(host.parkingHostId);
        }
      }
    }
    setActiveTab(value);
  };

  const checkActivated = (value) => {
    if (activeTab === -1) return true;
    return value === activeTab;
  };

  useEffect(() => {
    if (selectedHostName && isComponentVisibleForUser(UC_TAB_HOSTS, userUseCases)) {
      setActiveTab(0);
    }
  }, [selectedHostName]);

  const handleHostClick = (value) => {
    setSelectedHostName(value);
    setActiveTab(0);
  };

  const handleCardDetailOpenInner = (value) => {
    // if (value.hostName) {
    //   setSelectedHostName(value.hostName);
    //   setActiveTab(0);
    // }

    handleCardDetailOpen(value);
  };

  const hadleHostFavorite = (parkingHostId, favorite, type) => {
    updateHostFavorite(parkingHostId, favorite, type)
    .then(()=>{
    })
    .catch((err)=>{
      console.log('hadleHostFavorite - catch', err);
    })
  }

  const handleZoneFavorite = (parkingHostId, favorite, type) => {
    updateFavoriteZone(parkingHostId, favorite, type)
    .then(()=>{
    })
    .catch((err)=>{
      console.log('hadleHostFavorite - catch', err);
    })
  }


  const tabs = [
  ];
  const tabContents = [
  ];

  if (isComponentVisibleForUser(UC_TAB_HOSTS, userUseCases) && selected.connectionType!=='WIMQ' ) {
    tabs.push(<div style={{flexDirection:'row', display: 'flex', marginRight: '30px'}}><DashboardIcon style={{marginRight:'25px'}}/><div>{t('PARKING_HOSTS')}</div></div>);
    tabContents.push(<LocalParkingHosts
        parking={selected}
        active={checkActivated(tabContents.length)}
        selectedHostName={selectedHostName}
        setSelectedHostName={setSelectedHostName}
        handleCreateTaskOpen={handleTaskCreateOpen}
        handleCameraDetailOpen={handleCameraDetailOpen}
        withDetail={withDetail}
        sseParkingHosts={sseParkingHosts}
        favorites={favorites}
        sipCall={sipCall}
        sipStatus={sipStatus}
        calls={calls}
        userUseCases={userUseCases}
        hadleHostFavorite={hadleHostFavorite}
    />);
  };
  if (isComponentVisibleForUser(UC_TAB_EVENTS, userUseCases)) {
    tabs.push(<div style={{flexDirection:'row', display: 'flex', marginRight: '30px'}}><EventNoteIcon style={{marginRight:'25px'}}/><div>{t('PARKING_EVENTS')}</div></div>);
    tabContents.push(   <LocalParkingEvents
        parking={selected}
        active={checkActivated(tabContents.length)}
        handleCreateOpen={handleTaskCreateOpen}
        handleHostClick={handleHostClick}
        handleCardDetailOpen={handleCardDetailOpenInner}
        events={events}
        userUseCases={userUseCases}
    />);
  };
  if (isComponentVisibleForUser(UC_TAB_ZONES, userUseCases)) {
    tabs.push(<div style={{flexDirection:'row', display: 'flex', marginRight: '30px'}}><PieChartIcon style={{marginRight:'25px'}}/><div>{t('PARKING_ZONES')}</div></div>);
    tabContents.push(     <ParkingZones
        parking={selected}
        active={checkActivated(tabContents.length)}
        handleEditZoneOpen={handleEditZoneOpen}
        occupancy={occupancy}
        userUseCases={userUseCases}
        favorites={favorites}
        handleZoneFavorite={handleZoneFavorite}
    />);
  };
  if (isComponentVisibleForUser(UC_TAB_LT_CARDS, userUseCases) && selected.connectionType!=='WIMQ') {
    tabs.push(<div style={{flexDirection:'row', display: 'flex', marginRight: '30px'}}><CreditCardIcon style={{marginRight:'25px'}}/><div>{t('LONG_TERM_CARDS')}</div></div>);
    tabContents.push(    <ParkingCards
        cardType="LT"
        parking={selected}
        active={checkActivated(tabContents.length)}
        handleCardDetailOpen={handleCardDetailOpenInner}
        handleCreateCardOpen={handleCreateCardOpen}
        handleEditCardOpen={handleEditCardOpen}
        handleBlockCardOpen={handleBlockCardOpen}
        handleConfirmCardOpen={handleConfirmCardOpen}
        userUseCases={userUseCases}
    />);
  };
  if (isComponentVisibleForUser(UC_TAB_ST_CARDS, userUseCases) && selected.connectionType!=='WIMQ') {
    tabs.push(<div style={{flexDirection:'row', display: 'flex', marginRight: '30px'}}><CreditCardIcon style={{marginRight:'25px'}}/><div>{t('SHORT_TERM_CARDS')}</div></div>);
    tabContents.push(  <ParkingCards
        cardType="ST"
        parking={selected}
        active={checkActivated(tabContents.length)}
        handleCardDetailOpen={handleCardDetailOpenInner}
        handleCreateCardOpen={handleCreateCardOpen}
        handleEditCardOpen={handleEditCardOpen}
        handleBlockCardOpen={handleBlockCardOpen}
        handleConfirmCardOpen={handleConfirmCardOpen}
        userUseCases={userUseCases}
    />);
  };
  if (isComponentVisibleForUser(UC_TAB_TASKS, userUseCases)) {
    tabs.push(<div style={{flexDirection:'row', display: 'flex', marginRight: '30px'}}><CheckCircleOutlineIcon style={{marginRight:'25px'}}/><div>{t('TASKS')}</div></div>);
    tabContents.push(<MobileOperatorTasks
        parking={selected}
        active={checkActivated(tabContents.length)}
        handleTaskDetailOpen={handleTaskDetailOpen}
        handleCreateOpen={handleTaskCreateOpen}
        userUseCases={userUseCases}
    />);
  };

  const notConnectedTabContent = [
    <div className={classes.disconnectedContent}>
      <DisappointedIcon className={classes.disconnectedIcon} />
      <Typography variant="subtitle1">
        {t('PARKING_DATA_IS_NOT_AVAILABLE_A_THE_MOMENT_DUE_TO_LOST_OF_CONNECTION_WITH_PARKING')}
      </Typography>
    </div>,
  ];

  return (
    <div className={classes.container}>
      <div className={classes.titleWrapper}>
        <ParkingSymbol
          className={classes.symbol}
          color={selected.color}
          connectionType={selected.connectionType}
          widthSymbol={'66px'}
          width='60px'
          handleClick={selectParking(selected.parkingId)}
        />
        <div style={{marginBottom: '20px'}}>
        <Typography variant="h4" className={classes.title} >
          {selected.parkingName}
        </Typography>
        <div style={{display: 'flex', flexDirection: 'row'}}>
          { selected.isConnected &&
            <div                           
              style={{backgroundColor: '#D6E7B2', color: '#9BCA9A', marginLeft: '8px', width: '105px', borderRadius: '5px', padding: '3px',}}
            >
              <CheckIcon fontSize='small' style={{marginLeft: '5px', marginRight:'10px', marginBottom:'-3px'}}/>
              {t('CONNECTED')}
            </div>
          }
          { !selected.isConnected &&
            <div                           
              style={{backgroundColor: '#FDE6E2', color: '#F9C6BE', marginLeft: '8px', width: '105px', borderRadius: '5px', padding: '3px',}}
            >
              <NotInterestedIcon fontSize='small' style={{marginLeft: '5px', marginRight:'10px', marginBottom:'-3px'}}/>
              {t('DISCONNECTED')}
            </div>
          }
          { selected.apiMqConnection && selected.apiMqStatus == 'OK' &&
            <div                           
              style={{backgroundColor: '#D6E7B2', color: '#9BCA9A', marginLeft: '8px', width: '105px', borderRadius: '5px', padding: '3px',}}
            >
              <CheckIcon fontSize='small' style={{marginLeft: '5px', marginRight:'10px', marginBottom:'-3px'}}/>
              {t('API_MQ')}
            </div>
          }
          { selected.apiMqConnection && selected.apiMqStatus != 'OK' &&
            <div                           
              style={{backgroundColor: '#FDE6E2', color: '#F9C6BE', marginLeft: '8px', width: '105px', borderRadius: '5px', padding: '3px',}}
            >
              <NotInterestedIcon fontSize='small' style={{marginLeft: '5px', marginRight:'10px', marginBottom:'-3px'}}/>
              {t('API_MQ')}
            </div>
          }
        </div>
        </div>
      </div>

      <div className={classes.line}/>

      <div className={classes.container2} >
        <div className={classes.container3} >
          <div className={classes.onlineSwitchLabel}>{t('LOCAL_EQUIPMENT_STATUS')}</div>
            <ParkingHostCard 
              editable={false}
              userUseCases={userUseCases}
              parking={selected}
              key={selected.parkingId}
          />
        </div>
        <div className={classes.container3} >
          <div className={classes.onlineSwitchLabel}>{t('FAVORITE')}</div>
          <div className={classes.favoriteContainer}>
            {favorites && favorites.map((item)=>{
              return (
                <ParkingFavoriteCard
                  userUseCases={userUseCases}
                  parking={selected}
                  key={item.parkingFavoriteId}
                  favorite={item}
                  hadleHostFavorite={hadleHostFavorite}
                  handleZoneFavorite={handleZoneFavorite}
                  handleCreateTaskOpen={handleTaskCreateOpen}
                />)})}
          </div>
        </div>

      </div>

      <CustomTabs2
        activeTab={activeTab}
        tabs={tabs}
        tabContents={selected.isConnected ? tabContents : notConnectedTabContent}
        disabled={!selected.isConnected}
        // variant="fullWidth"
        handleChangeTab={handleChangeTab}
      />

      <div className={classes.line} style={{marginTop:'20px'}} />

    </div>
  );
}

LocalParking.propTypes = {
  selected: PropTypes.object.isRequired,
  handleTaskCreateOpen: PropTypes.func.isRequired,
  handleTaskDetailOpen: PropTypes.func.isRequired,
  handleCameraDetailOpen: PropTypes.func.isRequired,
  handleEditZoneOpen: PropTypes.func.isRequired,
  handleCardDetailOpen: PropTypes.func.isRequired,
  handleCreateCardOpen: PropTypes.func.isRequired,
  handleEditCardOpen: PropTypes.func.isRequired,
  handleBlockCardOpen: PropTypes.func.isRequired,
  handleConfirmCardOpen: PropTypes.func.isRequired,
  setSelectedHostName: PropTypes.func.isRequired,
  selectedHostName: PropTypes.string,
  events: PropTypes.array.isRequired,
  sseParkingHosts: PropTypes.array.isRequired,
  occupancy: PropTypes.array.isRequired,
};

LocalParking.defaultProps = {
  selectedHostName: null,
};

const mapStateToProps = (store) => ({
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  unRegistrePhoto,
  updateHostFavorite,
  updateFavoriteZone
}, dispatch);

const UC_TAB_HOSTS = 'UC0005';
const UC_TAB_EVENTS = 'UC0015';
const UC_TAB_ZONES = 'UC0018';
const UC_TAB_LT_CARDS = 'UC0020';
const UC_TAB_ST_CARDS = 'UC0029';
const UC_TAB_TASKS = 'UC0035';
const UC_TAB_OPERATORS = 'UC0039';


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LocalParking);
